import React, { useState, useEffect } from "react";
import styles from "./Header.module.scss";

// Import icons
import Heart from "../../components/icons/heart-solid.svg";
import Deals from "../../components/icons/category/deals.svg";
import Leaf from "../../components/icons/category/leaf.svg";
import Flower from "../../components/icons/category/flower.svg";
import Preroll from "../../components/icons/category/pre-roll.svg";
import Extract from "../../components/icons/category/extract.svg";
import Vape from "../../components/icons/category/vape.svg";
import Edible from "../../components/icons/category/edible.svg";
import Tincture from "../../components/icons/category/tincture.svg";
import Topical from "../../components/icons/category/topical.svg";
import Gear from "../../components/icons/category/gear.svg";
import Merch from "../../components/icons/category/merch.svg";
import Rewards from "../../components/icons/category/award.svg";
import Brands from "../../components/icons/category/brands.svg";
import Events from "../../components/icons/calendar.svg";
import Sale from "../../components/icons/category/sale.svg";
import Drink from "../../components/icons/category/drinks.svg";

import SkeletonTextHeader from "../../components/skeletons/SkeletonTextHeader";

export default function Header({ category, children, flexChildren }) {
  const [title, setTitle] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const categories = [
    { category: "all", icon: <Leaf /> },
    { category: "sale", icon: <Sale /> },
    { category: "deals", icon: <Deals /> },
    { category: "rewards", icon: <Rewards /> },
    { category: "brands", icon: <Brands /> },
    { category: "flower", icon: <Flower /> },
    { category: "pre-roll", icon: <Preroll /> },
    { category: "extract", icon: <Extract /> },
    { category: "vape", icon: <Vape /> },
    { category: "edible:drinks", icon: <Drink /> },
    { category: "edible", icon: <Edible /> },
    { category: "tincture", icon: <Tincture /> },
    { category: "topical", icon: <Topical /> },
    { category: "gear", icon: <Gear /> },
    { category: "merch", icon: <Merch /> },
    { category: "events", icon: <Events /> },
    { category: "favorites", icon: <Heart /> },
  ];

  useEffect(() => {
    if (category) {
      setTitle(category);
    }
    setIsLoading(false);
    console.log(category)
  }, [category]);

  const getCategoryIcon = () => {
    const matchedCategory = categories.find((i) => category?.includes(i.category));
    return matchedCategory ? matchedCategory.icon : <Leaf />;
  };

  if (isLoading) {
    return (
      <div className="container">
         <SkeletonTextHeader />
      </div>
    );
  }

  let titleContent;
  let categoryPath;
  if (title) {
    if (title.includes(":")) {
      [categoryPath] = title.split(":");
      titleContent = title.slice(categoryPath.length + 1);
    } else if (category === "all") {
      categoryPath = "shop";
      titleContent = "Shop All";
    } else {
      categoryPath = title;
      titleContent = decodeURI(title);
    }
  } else {
    return null;
  }

  return (
      <div className={`${styles.categoryHeader} ${styles[categoryPath]} container`}>
        <div className={`${styles.content} ${flexChildren ? styles.flexTitle : ""}`}>
          <div className={styles.title}>
            {getCategoryIcon()}
            <div className={styles.titleText}>
              <h1 className={styles.dynamicTitle}>
                {titleContent}
              </h1>
            </div>
          </div>
          {children}
        </div>
      </div>
  );
}
